import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { createRequestOption } from 'src/app/auth/request/request-util';
import { environment } from 'src/environments/environment';
import { AddProfile, Profile } from './profile';
import { EncryptService } from 'src/app/shared/encrypt.service';
export type EntityResponseType = HttpResponse<Profile>;
export type EntityArrayResponseType = HttpResponse<Profile[]>;

@Injectable({ providedIn: 'root' })
export class ProfileService {
    protected resourceFliterUrl = environment.SERVER_API_URL+('api/getProfilesByFilter');
    protected resourceFliterVaildUrl = environment.SERVER_API_URL+('api/getProfilesValidByFilter');
    protected getApproveProfilesUrl = environment.SERVER_API_URL+('api/getApproveProfilesByFilter');
    protected resourceSaveUrl = environment.SERVER_API_URL+('api/saveProfile');
    protected resourceDeleteUrl = environment.SERVER_API_URL+('api/deleteProfile');
    protected getProfileUrl = environment.SERVER_API_URL+('api/getProfile');
    protected bankAadhaarUrl = environment.SERVER_API_URL+('api/send-otp');
    protected bankOtpValidateUrl = environment.SERVER_API_URL+('api/Aadhaar-details');
    protected getImageUrl = environment.SERVER_API_URL+('api/getAadhaarPhoto');
    protected getApproveProfileStatus = environment.SERVER_API_URL+('api/ApproveProfileStatus');
    protected getLevelMasterHabitation = environment.SERVER_API_URL+('api/getLevelMasterHabitation');
    protected aadhaarUrl = environment.SERVER_API_URL+('api/getAadhaar');
    protected otpValidateUrl = environment.SERVER_API_URL+('api/getAadhaarDetails');
    constructor(protected http: HttpClient,private encryptService:EncryptService) {}
    filter(req?: any,filter?:any): Observable<EntityArrayResponseType> {
      if(filter === null){
        filter = []
      }
      const options = createRequestOption(req);
        return this.http
        .post<Profile[]>(this.resourceFliterUrl,filter, { params:options, observe: 'response' })
    }
    vaildFilter(req?: any,filter?:any): Observable<EntityArrayResponseType> {
      if(filter === null){
        filter = []
      }
      const options = createRequestOption(req);
        return this.http
        .post<Profile[]>(this.resourceFliterVaildUrl,filter, { params:options, observe: 'response' })
    }
    approveFilter(req?: any,filter?:any): Observable<EntityArrayResponseType> {
      if(filter === null){
        filter = []
      }
      const options = createRequestOption(req);
        return this.http
        .post<Profile[]>(this.getApproveProfilesUrl,filter, { params:options, observe: 'response' })
    }
    save(profile?:any): any {
 
        return this.http
        .post(this.resourceSaveUrl,profile, {observe: 'response' , responseType:'text'})
    }
    delete(id: number) {
      return this.http.delete(`${this.resourceDeleteUrl}?id=${id}`, { observe: 'response' , responseType:'text'});
    }

    getProfile(id: number): Observable<HttpResponse<any>> {
      return this.http.get<AddProfile>(`${this.getProfileUrl}?id=${id}`, { observe: 'response' });
    }

    
    getHabitation(id: number): Observable<HttpResponse<any>> {
      return this.http.get<any>(`${this.getLevelMasterHabitation}?id=${id}`, { observe: 'response' });
    }

    approveProfile(id: number) {
      return this.http.get(`${this.getApproveProfileStatus}?id=${id}`, { observe: 'response' , responseType:'text'});
    }

    bankSendOtp(aadhaarNo: number): any {
      return this.http.get(`${this.bankAadhaarUrl}?aadhaarNo=${aadhaarNo}`, { observe: 'response' , responseType: 'text'});
    }

    bankValidateOtp(aadhaarNo: number,otp:number): Observable<HttpResponse<{}>> {
      return this.http.get(`${this.bankOtpValidateUrl}?aadhaarNo=${aadhaarNo}&Otp=${otp}`,{ observe: 'response' });
    }

    getImage(aadhaarNo: number): Observable<any> {
      return this.http.get(`${this.getImageUrl}?aadhaarNo=${aadhaarNo}`,{ observe: 'response', responseType: 'text' });
    }

    sendOtp(aadhaarNo: number): Observable<HttpResponse<{}>> {
      return this.http.get(`${this.aadhaarUrl}?aadhaarNo=${aadhaarNo}`, { observe: 'response' });
    }

    validateOtp(aadhaarNo: number,otp:number): Observable<HttpResponse<{}>> {
      return this.http.get(`${this.otpValidateUrl}?aadhaarNo=${aadhaarNo}&otp=${otp}`, { observe: 'response' });
    }

   

    

     

}
